@if (field?.invalid && (showWithoutDirty ? true : field.dirty || field.touched)) {
<div class="alert alert-danger">
    @for (error of errorList.toArray(); track error) { @if (field?.errors?.[error.type]) {
    <div>
        {{ error.textInput || field.errors[error.type] }}
    </div>
    } }
</div>
}
